import { Textarea } from "@/components/ui/textarea";

interface DescriptionFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const DescriptionField = ({ value, onChange, placeholder }: DescriptionFieldProps) => {
  return (
    <div className="space-y-2">
      <label htmlFor="description" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
        Descripción (opcional)
      </label>
      <Textarea
        id="description"
        name="description"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || "Descripción del pago"}
        maxLength={100}
        className="w-full min-h-[80px]"
      />
    </div>
  );
};
